import { render, staticRenderFns } from "./AccumulatedInspections.vue?vue&type=template&id=e5511616&scoped=true&"
import script from "./AccumulatedInspections.vue?vue&type=script&lang=ts&"
export * from "./AccumulatedInspections.vue?vue&type=script&lang=ts&"
import style0 from "./AccumulatedInspections.vue?vue&type=style&index=0&id=e5511616&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5511616",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
